import { isSubscriptionActive } from 'src/utils/subscriptionExpire'
import { resolveDeviceOrderId } from 'src/utils/subscriptionStatus'

const expireMs = raw => {
  if (raw == null || raw === '') return 0
  const ms = new Date(raw).getTime()

  return Number.isFinite(ms) ? ms : 0
}

const sortByExpireDesc = (a, b) => expireMs(b?.expire_time) - expireMs(a?.expire_time)

export const findOrderById = (orders, orderId) => {
  if (!Array.isArray(orders) || orderId == null || orderId === '') return null

  return orders.find(item => String(item.id) === String(orderId)) || null
}

/**
 * 同一 device_id 可能多笔订单：未过期优先，再按 expire_time 最长。
 * 仅作 order_id 缺失时的兜底，不能替代设备上的当前单。
 */
export const pickOrderByDeviceId = (orders, deviceId, { preferActive = true } = {}) => {
  if (!Array.isArray(orders) || deviceId == null || deviceId === '') return null

  const matched = orders.filter(item => String(item.device_id) === String(deviceId))
  if (!matched.length) return null

  if (preferActive) {
    const active = matched.filter(item => isSubscriptionActive(item?.expire_time)).sort(sortByExpireDesc)
    if (active[0]) return active[0]
  }

  return [...matched].sort(sortByExpireDesc)[0] || null
}

/**
 * 为当前设备解析应对齐的订单。
 * 优先级：设备 order_id → 同 device_id 下未过期且到期最晚 → 同 device_id 到期最晚。
 *
 * @param {Array} orders
 * @param {object|string|number|null} deviceOrHint device / DeviceUser / 仅 device id
 */
export const matchOrderForDevice = (orders, deviceOrHint, options) => {
  if (!Array.isArray(orders) || !orders.length || deviceOrHint == null || deviceOrHint === '') {
    return null
  }

  const hint =
    typeof deviceOrHint === 'object'
      ? deviceOrHint
      : { device_id: deviceOrHint, id: deviceOrHint }

  const byOrderId = findOrderById(orders, resolveDeviceOrderId(hint))
  if (byOrderId) return byOrderId

  const deviceId = hint.device_id ?? hint.id
  if (deviceId == null || deviceId === '') return null

  return pickOrderByDeviceId(orders, deviceId, options)
}

export default matchOrderForDevice
